
import { ref, inject, shallowRef} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import headerMenu from '@/components/header/header.vue'
import GAinit from '@/plugins/googleAds'
import { Toast } from 'vant'
export default {
  components: {
    headerMenu
  },
  props:{},
  setup(props: object){
    // GA 注入
    GAinit();
    const tabbar_index = 1,
       $store: any = inject('$store'),
        $http: any = inject('$http'),
        router = useRouter(),
          currency: String = $store.getSite().currency, 
          currencyUnit:String = $store.getSymbol(),
        route = useRoute();
    
    let pay_datas: any = ref({});

    
    const view_init = async () => {
        let paream: any = {
            pay_sn: route.query.pay_sn
        }
        if(route.query.merchantOrderNo) {
            paream = {
                merchantOrderNo: route.query.merchantOrderNo
            }
        }
        let ret = await $http.get_pay_result(paream)
        if(ret.code === 200){
            pay_datas.value = ret.data

            // Pay to complete 
            if(ret.data.status === 1) {
                // facebook埋点
                if(!sessionStorage.getItem('fbq_purchase_order_sn')) {
                    sessionStorage.setItem('fbq_purchase_order_sn',JSON.stringify(ret.data.order_sn))
                    // @ts-ignore
                    fbq('track', 'Purchase', {currency: currency, value: ret.data.amount});
                } else if(sessionStorage.getItem('fbq_purchase_order_sn')  != JSON.stringify(ret.data.order_sn)){
                    sessionStorage.setItem('fbq_purchase_order_sn',JSON.stringify(ret.data.order_sn))
                    // @ts-ignore
                    fbq('track', 'Purchase', {currency: currency, value: ret.data.amount});
                }
                
                // google ads埋点
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-965268020/MTjdCOmI8PcBELSko8wD',
                    'value': ret.data.amount,
                    'currency': currency,
                    'transaction_id': ret.data.order_sn[0]
                });
            }
        }
        else{
            Toast.fail(ret.message);   
        }
    };
    /**
     * Click Buy More
     */
    const actv_home_fn = () => {
        router.push('/')
    };
    /**
     *  Click View Order
     */
    const actv_order_list_fn = () => {
        router.push('/order')
    }
    //  Init loading datas
    view_init()
    return {
        pay_datas,
        actv_home_fn,
        actv_order_list_fn

    }
  }
}
